import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

interface RejectConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RejectConfirmDialog({
  open,
  onClose,
  onConfirm,
}: RejectConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>تأكيد رفض الطلب</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <div className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="h-5 w-5" />
            <p className="text-sm">
              هل أنت متأكد من رفض هذا الطلب؟
            </p>
          </div>
          <p className="text-sm text-gray-500 mt-2">
            لا يمكن التراجع عن هذا الإجراء.
          </p>
        </div>
        <DialogFooter className="gap-2">
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            تأكيد الرفض
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
          >
            إلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}